export enum ExaminationType {
  HS_EXAMINATION = 'HS_EXAMINATION',
  POLYCLINIC_EXAMINATION = 'POLYCLINIC_EXAMINATION',
  IBYS_EXAMINATION = 'IBYS_EXAMINATION',
  NURSING_PROCESS = 'NURSING_PROCESS',
  OTHER = 'OTHER',
}
